import UserRailyOfficerListRequest, {
  UserRailyOfficerListRequestQueryParams,
} from "./user-raily-officer-list.request";

const createQueryParams = (
  data: UserRailyOfficerListRequest,
): UserRailyOfficerListRequestQueryParams => {
  return {
    creationEnd: data.creationEnd,
    creationStart: data.creationStart,
    limit: data.limit,
    offset: data.offset,
    firstName: data.firstName,
    lastName: data.lastName,
    email: data.email,
    username: data.username,
    order: data.order,
    statusCriteria: data.statusCriteria,
  };
};

const userRailyOfficerListRequestFactory = {
  createQueryParams,
};

export default userRailyOfficerListRequestFactory;
